/**
 * Why an admin removes a PPA - the same list as corpers.online's `utilities/ppaDeletion.js`; keep
 * them in step. A duplicate is merged into the PPA it duplicates, not deleted.
 */
export type PpaDeletionCategory = 'duplicate' | 'spam' | 'not_a_real_ppa' | 'inappropriate' | 'other'

export const PPA_DELETION_CATEGORIES: Array<{ value: PpaDeletionCategory; label: string }> = [
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'spam', label: 'Spam' },
  { value: 'not_a_real_ppa', label: 'Not a real PPA' },
  { value: 'inappropriate', label: 'Inappropriate' },
  { value: 'other', label: 'Other' },
]

export function ppaDeletionCategoryLabel(category: string | null | undefined): string {
  return PPA_DELETION_CATEGORIES.find((c) => c.value === category)?.label ?? 'Other'
}

/** Categories whose name is worth blocking - a duplicate's or a mistake's isn't. */
export const BLOCKABLE_CATEGORIES: PpaDeletionCategory[] = ['spam', 'not_a_real_ppa', 'inappropriate']

/** "6 months" for 180 days, "14 days" for 14 - how long a deleted PPA can be restored. */
export function retentionText(days: number): string {
  if (days >= 60 && days % 30 === 0) return `${days / 30} months`
  return `${days} day${days === 1 ? '' : 's'}`
}
